'use client'

import { AgentHandoffButton } from '@/components/mcp/agent-handoff-button'
import { buildAgentPrompt } from '@/lib/mcp/handoff'

export type ChatHandoffButtonProps = {
  chatId: string
  /** Active brand name — adds the brand clause to the handoff prompt. */
  brandName?: string
  /** The composer's runtime status — the button hides while a turn is in flight. */
  status: 'submitted' | 'streaming' | 'ready' | 'error'
}

/**
 * Chat adapter for the shared agent handoff. It only gates settled turns and
 * builds a context-resume prompt; the shared control owns the complete UI.
 */
export function ChatHandoffButton({
  chatId,
  brandName,
  status,
}: ChatHandoffButtonProps) {
  // Only offer the hand-off once the turn is settled (a clean, complete context).
  if (status !== 'ready' && status !== 'error') {
    return null
  }

  const prompt = buildAgentPrompt({ kind: 'chat', chatId, brandName })

  return <AgentHandoffButton prompt={prompt} menuSide="top" />
}
